module.exports = __webpack_public_path__ + "static/img/img-zixun2.43f78b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-zixun2.png
// module id = fLYQ
// module chunks = 1